export default __webpack_public_path__ + "static/media/telecommunications.f89b9c75.jpg";